import React from 'react';

import LoginCreds from '../../components/loginpages/LoginCreds';
import { TSPCategory, TSPConfig } from '../types';

const threepltekConfig: TSPConfig = {
  key: '3pltek',
  name: '3PLTEK',
  imageName: '3PLTEK',
  category: TSPCategory.CUSTOM,
  helpText:
    "Please input the company ID from your 3PLTEK profile. It should start with 'Company:' (like 'Company:12345').",
  loginComponent: (props) => (
    <LoginCreds
      onValidityChange={props.onValidityChange}
      fields={[
        {
          label: 'Enter Company ID (e.g. Company:12345)',
          name: 'apikey',
          type: 'text',
          required: true,
        },
      ]}
    />
  ),
};

export default threepltekConfig;
